import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FooterList } from 'components';
// import { ReactComponent as AccountSvg } from 'assets/svg/account-line.svg';
import { ReactComponent as LogoutSvg } from 'assets/svg/logout-line.svg';
// import { ReactComponent as TreadSvg } from 'assets/svg/thread-line.svg';
// import { ReactComponent as HashSvg } from 'assets/svg/hash-line.svg';

export const Drawer = props => {
  // const [account, setAccount] = useState(false);

  return (
    <div>
      {/*<Account show={account} toggle={() => setAccount(!account)} /> */}

      <div
        className={classnames('drawer', {
          active: props.active
        })}
      >
        <div className="drawer--container drawer--bordered">
          <div className="profile">
            <div className="profile__header">
              <Link className="profile__avatar" to="/profile">
                <img src="https://picsum.photos/200" alt="avatar" />
              </Link>

              <Link to="/profile" className="profile__name">
                <h3 className="drawer__title">Dante Lex</h3>
                <h4 className="drawer__subtitle">@dantelex</h4>
              </Link>
            </div>

            {/* <div className="profile__streak">
              <FlameSvg width={77} height={77} />

              <h3 className="wrapper__drawer__title">0</h3>
              <h4 className="wrapper__drawer__subtitle">STREAK</h4>
      </div> */}
          </div>

          <div className="thread">
            <div className="thread__stats">
              <p className="thread__stats__text">
                <span>30</span> Treads
              </p>
            </div>
          </div>
        </div>
        {/*<div className="drawer--container drawer--bordered drawer__atread">
          <div className="drawer__titlein">
            <h4 className="drawer__subtitle">
              This keeps you connected to the current or last tread you were on.
            </h4>
          </div>

          <div className="drawer__menu">
            <ul className="menu">
              <li className="menu__item">
                <Link
                  to="/t/tread"
                  className="menu__link menu__link--lasttread"
                >
                  <TreadSvg width={18} height={18} />
                  Go To Last Tread
                </Link>
              </li>
            </ul>
          </div>
    </div> */}
        <div className="drawer--container drawer--bordered">
          <div className="drawer__menu">
            <ul className="menu">
              {/* <li className="menu__item">
                <a
                  href="#"
                  className="menu__link"
                  onClick={() => setAccount(!account)}
                >
                  <AccountSvg width={20} height={20} />
                  Account
                </a>
    </li> */}
              <li className="menu__item">
                <Link to="/" className="menu__link">
                  <LogoutSvg width={20} height={20} />
                  Logout
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="drawer--container drawer__footer">
          <div className="drawer__menu footer">
            <FooterList menuFooter />
          </div>
        </div>
      </div>
    </div>
  );
};

Drawer.propTypes = {
  active: PropTypes.bool
};
